// extracted by mini-css-extract-plugin
export var compactFilters = "_ew-4";
export var detailImage = "_ew-1";
export var dropdownContainer = "_ew-2";
export var imageContainer = "_ew-0";
export var selectedCard = "_ew-3";